export const MYMENIGO_DROPDOWN_BOX_OPEN = 'MYMENIGO_DROPDOWN_BOX_OPEN';
export const MYMENIGO_DROPDOWN_BOX_CLOSE = 'MYMENIGO_DROPDOWN_BOX_CLOSE';
export const setMyMenigoDropdownOpen = () => {
    return {
        type: MYMENIGO_DROPDOWN_BOX_OPEN,
    };
};
export const setMyMenigoDropdownClose = () => {
    return {
        type: MYMENIGO_DROPDOWN_BOX_CLOSE,
    };
};
